import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { DataRest } from "../model/api/data-rest";
import { environment } from "src/environments/environment";
import { resources } from "./api";
import { Observable } from "rxjs";
import { MtmaUploadData } from "../model/mtma-import-export-file";
import { MtmaUploadResponseData } from "../model/api/data-rest";

@Injectable({
   providedIn: 'root'
})
export class DeviceMtmaService {
   constructor(
      private http: HttpClient
   ) { }

   postMtmaImportCsv(deviceId: number, userId: number, mtmaUploadData: MtmaUploadData): Observable<MtmaUploadResponseData> {
      let params: HttpParams = new HttpParams();
      params = new HttpParams().set('userId', userId.toString());
      return this.http.post<MtmaUploadResponseData>(`${environment.apiUrl}${resources.get('v1')}${resources.get('mtma')}/${deviceId}${resources.get('upload')}`, mtmaUploadData, { params });
   }
}